import * as actions from '../translationActions';

const initialState = {
  language: localStorage.getItem('i18nextLng') || 'en-US',
  languages: [],
};

const changeLanguage = (state, payload) => {
  state = Object.assign({}, state, {
    language: payload,
  });

  return state;
};

const updateLanguages = (state, payload) => {
  state = Object.assign({}, state, {
    languages: payload,
  });

  return state;
};

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.CHANGE_LANGUAGE:
      return changeLanguage(state, payload);
    case actions.UPDATE_SITE_LANGUAGES:
      return updateLanguages(state, payload);
  }
  return state;
};
